<template>
  <div id="app" style="position: relative;">
    <header-cmp :class="{active: headerActive }" :isHeaderActive="headerActive" v-if="!$route.path.includes('/admin')"></header-cmp>

    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>

    <footer-cmp></footer-cmp>
    
    <!-- go up button  -->
    <transition name="fade" mode="out-in" appear>
        <button class="goup-btn" v-if="toUp" @click="goUp('up')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 18.75 7.5-7.5 7.5 7.5" />
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 7.5-7.5 7.5 7.5" />
            </svg>
        </button>
    </transition>
    
    <div class="cookies-window" v-if="hasCookies">

      <button class="close" @click="hasCookies = false">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="content">
        <strong>We value your privacy</strong>
        <p>
          We use cookies to analyze site useage and improve our website and services.
          <br>
          Click "Cookies Seetings" to manage your references.
        </p>
        <span>
            cookies settings
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
          </span>
      </div>
      

      <div class="actions">
        <button>Customize</button>
        <button>Aceept all</button>
      </div>
    </div>
  </div>
</template>

<script>
import FooterCmp from "./components/footer-cmp.vue";
import headerCmp from "./components/header-cmp.vue"
export default {
    data() {
        return {
          toUp: false,
          headerActive: false,
          hasCookies: false //!document.cookie
        }
    },
    watch: {
      "$route.path"(v) {
        this.goUp('up');
        this.goUp();
        
        const formPaths = [
          '/services/request-quote', 
          '/services/test-drive', 
          '/services/maintenance', 
          '/services/fleet-solutions',
          '/contact'
        ]        
        if (formPaths.includes(v)) {
          location.reload();
        }
      }
    },
    methods: {
      goUp(direction) {
            let scrolller = window.scrollY;
            if (direction) return window.scrollTo(0,0);
            else {
              if (scrolller >= 200) {
                this.toUp = true;
                this.headerActive = true;
              }
              else {
                this.toUp = false;
                if (this.$route.path.startsWith('/news')) {
                  this.headerActive = true;
                } else {this.headerActive = false;}
              }
            }
        },
    },
    components: {
        'header-cmp': headerCmp,
        'footer-cmp': FooterCmp
    },
    mounted() {
        window.addEventListener('scroll', () => {
            this.goUp()
        });
    },
}
</script>



<style>
.fade-enter-active,
.fade-leave-active,
.fade-appear-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-appear {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}



.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s ease;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
  overflow: hidden;
}

.slide-enter-to,
.slide-leave {
  max-height: 500px; /* max height of content */
  padding-top: 10px;
  padding-bottom: 10px;
  opacity: 1;
  overflow: hidden;
}
</style>